import React, { useEffect, useRef, useState } from 'react';
import { SwipeableHandlers } from 'react-swipeable';
import { useDispatch, useSelector } from 'react-redux';
import { Slide } from '@material-ui/core';

import { Article } from '../../../../../types/items';
import NoPreview from './NoPrivew';
import MediaPreviewStyles from './styles';
import {
  selectCurrentDocumentPageIndex, selectDocumentPage,
} from '../../../../../store/modules/articles/selectors';
import { Spinner } from '../../../../../components';
import {
  setCurrentArticleDocumentPage,
  setCurrentDocumentPageIndexMediaViewer,
} from '../../../../../store/modules/articles/actions';
import { getLargeDocumentThumbnailUrl } from '../utils';

type Props = {
  media: Article;
  swipeable?: SwipeableHandlers;
  slideDirection: 'left' | 'right' | 'up' | 'down';
  isChangePreviewMedia: number | null;
};

const MediaPages = ({ media, swipeable, slideDirection, isChangePreviewMedia }: Props) => {
  const dispatch = useDispatch();
  const classes = MediaPreviewStyles();
  const isProcessingMedia = media.ref.document?.ref?.is_processing || false;
  const { loading, data: documentPages, current: currentPage } = useSelector(selectDocumentPage);
  const imageRef = useRef<HTMLImageElement>(null);
  const [isLoading, setLoading] = useState(false);
  const currentIndex = useSelector(selectCurrentDocumentPageIndex);
  const documentThumbnail = media.ref.document?.thumbnails;
  const documentImage = documentThumbnail ? getLargeDocumentThumbnailUrl(documentThumbnail) : '';
  const currentImage = (currentPage?.url.url) ? currentPage?.url.url : documentImage;

  /* eslint react-hooks/exhaustive-deps: 0 */
  useEffect(() => {
    if (documentPages && currentIndex > 1 && currentIndex !== currentPage?.id) {
      if (documentPages[currentIndex - 1]) {
        dispatch(setCurrentArticleDocumentPage(documentPages[currentIndex - 1]));
      }
    }
  }, [documentPages]);

  useEffect(() => () => {
    dispatch(setCurrentDocumentPageIndexMediaViewer(1));
    if (documentPages && documentPages.length) {
      dispatch(setCurrentArticleDocumentPage(documentPages[0]));
    }
  }, [dispatch, documentPages]);

  useEffect(() => {
    if (currentPage?.url.url) {
      const image = new Image();
      image.src = currentPage.url.url;
      setLoading(!image.complete);
    }
  }, [currentPage]);

  if (!documentPages?.length && loading) {
    return (
      <Slide
        direction={slideDirection}
        in={isChangePreviewMedia === null}
        mountOnEnter
        unmountOnExit
      >
        <div {...swipeable} className={classes.wrapper}>
          {isLoading && <Spinner />}
        </div>
      </Slide>
    );
  }

  if (isProcessingMedia || loading || !currentImage) {
    return <NoPreview
      swipeable={swipeable}
      slideDirection={slideDirection}
      isChangePreviewMedia={isChangePreviewMedia}
    />;
  }

  return (
    <Slide
      direction={slideDirection}
      in={isChangePreviewMedia === null}
      mountOnEnter
      unmountOnExit
      timeout={300}
    >
      <div {...swipeable} className={classes.wrapper}>
        {isLoading && <Spinner />}
        <img
          hidden={isLoading}
          ref={imageRef}
          src={currentImage}
          alt=""
          className={classes.image}
          onLoad={() => setLoading(false)}
        />
      </div>
    </Slide>
  );
};

export default MediaPages;
